export default __webpack_public_path__ + "static/media/twitter.5f3df2a4.svg";